<template>
    <div v-if="show" class="py-5 px-8 rounded items-top"
         :class="[type === 'success' && 'bg-semitone-color-1', type === 'error' && 'bg-semitone-color-3', type === 'default' && 'bg-semitone-primary-1']">
        <img
            v-if="showCloseButton"
            src="../../assets/icons/close.svg"
            class="h-2.5 w-2.5  ml-auto cursor-pointer"
            aria-hidden="true"
            @click="show = false" alt="close"
        />
        <slot/>
    </div>
</template>
<script setup>
import {ref} from 'vue'

const props = defineProps({
    type: {
        type: String,
        validator: function (value) {
            return ['success', 'error', 'default'].indexOf(value) !== -1;
        }
    },
    showCloseButton: {
        type: Boolean,
        default: true,
    }
});

const show = ref(true);
</script>